import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'StatsSet';

const StatsSetApi: any = baseApi(endpoint);

export default StatsSetApi;